import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefConditionCustomizeExportNsc = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      colId: 'isApplied',
      headerName: '',
      headerTooltip: t('grid.apply'),
      cellRenderer: 'selectConditionCustomizeRenderer',
      minWidth: 50,
      maxWidth: 50,
    },
    {
      field: 'customer1',
      headerName: t('condition.customer1'),
      headerTooltip: t('condition.customer1'),
      width: 100,
    },
    {
      field: 'customer1Name',
      headerName: t('condition.customerName1'),
      headerTooltip: t('condition.customerName1'),
      tooltipField: 'customer1Name',
      width: 250,
    },
    {
      field: 'customer2',
      headerName: t('condition.customer2'),
      headerTooltip: t('condition.customer2'),
      width: 100,
    },
    {
      field: 'customer2Name',
      headerName: t('condition.customerName2'),
      headerTooltip: t('condition.customerName2'),
      tooltipField: 'customer2Name',
      width: 250,
    },
    {
      field: 'standard',
      headerName: t('millSheet.standard'),
      headerTooltip: t('millSheet.standard'),
      tooltipField: 'standard',
      width: 100,
    },
    {
      field: 'sizeDisplay',
      headerName: t('millSheet.size'),
      headerTooltip: t('millSheet.size'),
    },
  ];

  return colDefs;
};

export default useColdefConditionCustomizeExportNsc;
